import { advancedThrottle, onWindowResize, removeOnWindowResize } from "./utils"

class TruncatableContent extends HTMLElement {
  constructor() {
    super()

    this.throttleHandleRenderLogic = advancedThrottle(this.handleRenderLogic.bind(this), 250)
    this.expandClickHandler = this.expandClickHandler.bind(this)
    this.shrinkClickHandler = this.shrinkClickHandler.bind(this)
  }

  connectedCallback() {
    this.truncatable = this.querySelector(".truncatable-content")
    this.expand = this.querySelector(".expand")
    this.shrink = this.querySelector(".shrink")

    if (!this.truncatable || !this.expand || !this.shrink) return

    this.handleRenderLogic()

    onWindowResize(this.throttleHandleRenderLogic)
  }

  handleRenderLogic() {
    if (
      this.truncatable.offsetHeight < this.truncatable.scrollHeight ||
      this.truncatable.offsetWidth < this.truncatable.scrollWidth
    ) {
      if (this.classList.contains("expanded"))
        // adjust expanded truncatable content height on window resize
        this.truncatable.style.maxHeight = this.truncatable.scrollHeight + "px"
      this.renderExpandShrink()
    } else {
      this.removeExpandShrink()
    }
  }

  expandClickHandler(e) {
    e.preventDefault()
    e.stopPropagation()
    this.truncatable.style.maxHeight = this.truncatable.scrollHeight + "px"
    this.classList.add("expanded")
  }

  shrinkClickHandler(e) {
    e.preventDefault()
    e.stopPropagation()
    this.truncatable.style.maxHeight = null
    this.classList.remove("expanded")
  }

  renderExpandShrink() {
    this.classList.add("truncated")
    this.expand.addEventListener("click", this.expandClickHandler)
    this.shrink.addEventListener("click", this.shrinkClickHandler)
  }

  removeExpandShrink() {
    this.classList.remove("truncated")
    this.expand.removeEventListener("click", this.expandClickHandler)
    this.shrink.removeEventListener("click", this.shrinkClickHandler)
  }

  disconnectedCallback() {
    removeOnWindowResize(this.throttleHandleRenderLogic)
  }
}

if (!customElements.get("truncatable-content")) {
  customElements.define("truncatable-content", TruncatableContent)
}
